import { Children, isValidElement, useMemo } from "react";
import { isDev } from "../../../../base/index.js";
import { ToolbarRail } from "../../ToolbarRail/ToolbarRail.js";
import { ToolbarViews } from "../../ToolbarViews/ToolbarViews.js";
function isValidRail(value) {
  return isValidElement(value) && value.type === ToolbarRail;
}
function isValidViewsGroup(value) {
  return isValidElement(value) && value.type === ToolbarViews;
}
function useToolbarChildren(children) {
  return useMemo(() => {
    const rail = Children.toArray(children).filter(isValidRail).at(0);
    const views = Children.toArray(children).filter(isValidViewsGroup).at(0);
    const totalFiltered = (views ? 1 : 0) + (rail ? 1 : 0);
    if (isDev() && totalFiltered !== Children.count(children)) {
      console.warn(
        "Toolbar only accepts a single ToolbarRail and and a single ToolbarViews components as children.",
        "Other children are not rendered."
      );
    }
    return {
      rail,
      views
    };
  }, [children]);
}
export {
  useToolbarChildren
};
//# sourceMappingURL=useToolbarChildren.js.map
